import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-drug-view-pop-up',
  templateUrl: './drug-view-pop-up.component.html',
  styleUrl: './drug-view-pop-up.component.scss'
})
export class DrugViewPopUpComponent implements OnInit {
  DrugList: any[] = [];
  constructor(
    public dialogRef: MatDialogRef<DrugViewPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }


  ngOnInit() {
    this.DrugList = this.data?.item?.drugs_ai || [];
  }

}